import type { FC } from "react";
import { useEffect, useState } from "react";
import { Outlet } from "react-router";
import UserProvider from "../../providers/user/UserProvider";
import MetaDataProvider from "../../providers/metaData/MetaDataProvider";
import TomanAnimatedLogo from "../../components/TomanAnimatedLogo";
import { useKeycloak } from "../../providers/keycloak/keycloakContext";

const AuthGuard: FC = () => {
  const { authState, keycloakService } = useKeycloak();
  const [hasRedirected, setHasRedirected] = useState(false);

  useEffect(() => {
    if (!authState.isLoading && !authState.isAuthenticated && !hasRedirected) {
      setHasRedirected(true);
      keycloakService.login();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authState.isLoading, authState.isAuthenticated, hasRedirected]);

  if (authState.isLoading) {
    return <TomanAnimatedLogo />;
  }

  if (!authState.isAuthenticated) {
    return <TomanAnimatedLogo />;
  }

  return (
    <MetaDataProvider>
      <UserProvider>
        <Outlet />
      </UserProvider>
    </MetaDataProvider>
  );
};

export default AuthGuard;
